// import React from 'react'
// import { Bar, Line } from 'react-chartjs-2';
// import Chart from 'chart.js/auto';
// import {CategoryScale} from 'chart.js'; 
// import moment from 'moment';
// Chart.register(CategoryScale);

// export default function DashboardGraph({graphData, graphData2, title, chartType, type, labelType}) {
//    console.log("graphData2", graphData2)
//   console.log("graphData2", graphData2)
//   const successOrderGraph = {
//     labels: (graphData2?.length > graphData?.length
//       ? graphData2?.map((item) => labelType === "hour" ? moment(item?._id).format('LTS') : item?._id)
//       : graphData?.map((item) => labelType === "hour" ? moment(item?._id).format('LTS') : item?._id)),
//     datasets: [
//       {
//         label: "Previous Period",
//         data: graphData?.map((item) => 
//           type === 1 ? item?.totalPayableAmount + item?.codChargesAmount :
//           type === 2 ? item?.totalOrders : 
//           null
//         ) || [],
//         fill: true,
//         backgroundColor: "rgb(242 68 98 / 15%)",
//         borderColor: "#b5496f",
//         tension: 0.5,
//         borderWidth: 1.5,
//         pointBorderWidth: 0,
//         pointRadius: 0,
//       },
//       {
//         label: "Latest Period",
//         data: graphData2?.map((item) => 
//           // console.log("item?.totalOrders", item?.totalOrders),
//           type === 1 ? item?.totalPayableAmount + item?.codChargesAmount : 
//           type === 2 ? item?.totalOrders : 
//           null
//         ) || [],
//         fill: true,
//         backgroundColor: "rgba(36, 160, 237, 0.2)", 
//         borderColor: "#24a0ed",
//         tension: 0.5,
//         borderWidth: 1.5,
//         pointBorderWidth: 0,
//         pointRadius: 0,
//       }
//     ]
//   };
  
//   return (
//     !chartType ? <Bar data={successOrderGraph} /> : <Line data={successOrderGraph} />
//   )
// }

import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import moment from 'moment';

Chart.register(CategoryScale);

export default function DashboardGraph({ graphData = [], graphData2 = [], title, chartType, type, labelType }) {
  // 1. Format time labels (hour or default)
  const formatLabel = (id) =>
    labelType === 'hour'
      ? moment(id).local().format('LT') // Use local time like "5:00 AM"
      : id;

  // 2. Create label set from both arrays
  const labelSet = new Set();
  graphData.forEach(item => labelSet.add(formatLabel(item._id)));
  graphData2.forEach(item => labelSet.add(formatLabel(item._id)));

  // 3. Sort labels chronologically if labelType is hour
  const labels = Array.from(labelSet).sort((a, b) =>
    labelType === 'hour'
      ? moment(a, 'LT').diff(moment(b, 'LT'))
      : a.localeCompare(b)
  );

  // 4. Create label-to-value maps
  const mapDataByLabel = (data) => {
    const map = {};
    data.forEach(item => {
      const key = formatLabel(item._id);
      map[key] =
        type === 1
          ? (item?.totalPayableAmount ?? 0) + (item?.codChargesAmount ?? 0)
          : type === 2
          ? item?.totalOrders ?? 0
          : 0;
    });
    return map;
  };

  const dataMap1 = mapDataByLabel(graphData);
  const dataMap2 = mapDataByLabel(graphData2);

  const dataset1 = labels.map(label => dataMap1[label] ?? 0);
  const dataset2 = labels.map(label => dataMap2[label] ?? 0);

  const successOrderGraph = {
    labels,
    datasets: [
      {
        label: 'Previous Period',
        data: dataset1,
        fill: true,
        backgroundColor: 'rgb(242 68 98 / 15%)',
        borderColor: '#b5496f',
        tension: 0.5,
        borderWidth: 1.5,
        pointBorderWidth: 0,
        pointRadius: 0,
      },
      {
        label: 'Latest Period',
        data: dataset2,
        fill: true,
        backgroundColor: 'rgba(36, 160, 237, 0.2)',
        borderColor: '#24a0ed',
        tension: 0.5,
        borderWidth: 1.5,
        pointBorderWidth: 0,
        pointRadius: 0,
      },
    ],
  };

  return chartType === 'line' ? <Line data={successOrderGraph} /> : <Bar data={successOrderGraph} />;
}
